import React from 'react';
import PropTypes from 'prop-types';

const ModalButtons = ({
  buttons = [],
  alignment = 'right', // 'left', 'center', 'right', 'space-between'
  className = '',
  style = {},
  spacing = 'mx-2',
  isSticky = true,
}) => {
  const getAlignmentClass = () => {
    switch (alignment) {
      case 'left':
        return 'justify-content-start';
      case 'center':
        return 'justify-content-center';
      case 'space-between':
        return 'justify-content-between';
      case 'right':
      default:
        return 'justify-content-end';
    }
  };

  const containerStyles = {
    ...(isSticky
      ? {
          position: 'sticky',
          width: '100%',
          bottom: 0,
          backgroundColor: 'white',
          borderTop: '1px solid #eee',
          padding: '.8rem 0.2rem',
          zIndex: 10,
          marginTop: 'auto',
        }
      : {}),
    ...style,
  };

  return (
    <div
      className={`modal-buttons-container ${className}`}
      style={containerStyles}
    >
      <div className={`d-flex ${getAlignmentClass()}`}>
        {buttons.map((ButtonComponent, index) => (
          <div key={index} className={spacing}>
            {ButtonComponent}
          </div>
        ))}
      </div>
    </div>
  );
};

ModalButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.element).isRequired,
  alignment: PropTypes.oneOf(['left', 'center', 'right', 'space-between']),
  className: PropTypes.string,
  style: PropTypes.object,
  spacing: PropTypes.string,
  isSticky: PropTypes.bool,
};

export default ModalButtons;
